import { QuoteFieldUpdate } from "./QuoteFieldUpdate";
import { InlineContactCard } from "./InlineContactCard";
import { InlineWhatsAppButton } from "./InlineWhatsAppButton";
import { AlternativeCarriersList } from "./AlternativeCarriersList";
import { SuggestedFollowups } from "./SuggestedFollowups";

interface ToolInvocationProps {
  toolInvocation: any;
  addToolResult?: (result: { toolCallId: string; result: string }) => void;
  onSendMessage?: (text: string) => void;
  sessionId: string;
  carrierId: string;
}

export const ToolInvocation = ({
  toolInvocation,
  addToolResult,
  onSendMessage,
  sessionId,
  carrierId,
}: ToolInvocationProps) => {
  const { toolName, toolCallId, state } = toolInvocation;
  // v6 saves input/output, v4 used args/result — support both
  const args = toolInvocation.args ?? toolInvocation.input;
  const result = toolInvocation.result ?? toolInvocation.output;

  switch (toolName) {
    case "getCarrierContactTool":
      return (
        <InlineContactCard
          result={result}
          state={state}
          sessionId={sessionId}
          carrierId={args?.carrierId || carrierId}
          onSendMessage={onSendMessage}
        />
      );
    case "findAlternativeCarriersTool":
      return (
        <AlternativeCarriersList
          result={result}
          state={state}
          sessionId={sessionId}
          onSendMessage={onSendMessage}
        />
      );
    case "contactViaWhatsApp":
      return (
        <InlineWhatsAppButton
          result={result}
          state={state}
          carrierId={carrierId}
        />
      );
    case "suggestFollowupsTool":
      return (
        <SuggestedFollowups
          result={result}
          state={state}
          sessionId={sessionId}
          carrierId={carrierId}
          onSendMessage={onSendMessage}
        />
      );
    case "updateQuoteField":
      return (
        <QuoteFieldUpdate
          toolCallId={toolCallId}
          state={state}
          args={args}
          result={result}
        />
      );
    case "finishQuoteTool":
    case "submitQuoteTool":
    case "modifyQuoteTool":
      // These tools don't render anything visible
      return null;
    default:
      return null;
  }
};
